export default __webpack_public_path__ + "static/media/ic_soundon.abafdcc0.svg";